import { css } from 'styled-components';
import { theme } from './theme';

export const borderedContent = css`
  border: 1px solid ${theme.colors.border};
  border-radius: 4px;
`;

export const level1Content = css`
  ${borderedContent};
  background-color: ${theme.colors.level1};
`;

export const optionHover = css`
  background-color: ${theme.colors.blue500};
  color: ${theme.colors.mainBlue};
`;

export const formInputStyles = css`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  background: ${theme.colors.white};
  color: ${theme.colors.secondary900};
  ${borderedContent};
  body.dark & {
    background: ${theme.colors.level0};
  }
`;

export const floatingComponentStyles = css`
  background-color: ${theme.colors.level2};
  border-radius: 4px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  body.dark & {
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.4);
  }
`;

export const overflowingStyles = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  // If text overflows with ellipsis in Safari,
  // it automatically displays a native tooltip which clashes with our tooltip.
  // Workaround: https://stackoverflow.com/a/43915246
  &::after {
    content: '';
    display: block;
  }
`;
